import { ForgotPasswordTranslation } from '../../types/forgotPassword.types';

export const forgotPassword: ForgotPasswordTranslation = {
  title: 'Recuperación de Contraseña',
  form: {
    emailPlaceholder: 'Ingrese su e-mail',
    emailLabel: 'E-MAIL',
    submit: 'ENVIAR',
  },
  successMessage:
    'Si el correo proporcionado está registrado, recibirá una nueva contraseña en breve. Utilícela para acceder al sistema.',
  backToLogin: 'Volver al inicio de sesión',
};

export default forgotPassword;
